/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiConverter,
  AiConverterRequestInput,
  ListAiConvertersParams,
  PaginatedAiConverters,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Converter
 */
export const createAiConverter = (
    aiConverterRequestInput: MaybeRefOrGetter<AiConverterRequestInput>,
 signal?: AbortSignal
) => {
      aiConverterRequestInput = toValue(aiConverterRequestInput);

      return axiosClient<void>(
      {url: `/ai/converters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiConverterRequestInput, signal
    },
      );
    }




export const getCreateAiConverterMutationKey = () => ['createAiConverter'] as const;

export const getCreateAiConverterMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiConverter>>, TError,CreateAiConverterMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiConverter>>, TError,CreateAiConverterMutationVariables, TContext> => {

const mutationKey = getCreateAiConverterMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiConverter>>, CreateAiConverterMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAiConverter(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiConverterMutationResult = NonNullable<Awaited<ReturnType<typeof createAiConverter>>>
    export type CreateAiConverterMutationBody = AiConverterRequestInput
    export type CreateAiConverterMutationError = ErrorType<void>
    export type CreateAiConverterMutationVariables = {data: AiConverterRequestInput}

    /**
 * @summary Create AI Converter
 */
export const useCreateAiConverter = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiConverter>>, TError,CreateAiConverterMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiConverter>>,
        TError,
        CreateAiConverterMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAiConverterMutationOptions(options), queryClient);
    }
    /**
 * @summary List AI Converters
 */
export const listAiConverters = (
    params?: MaybeRefOrGetter<ListAiConvertersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiConverters>(
      {url: `/ai/converters`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiConvertersQueryKey = (params?: MaybeRefOrGetter<ListAiConvertersParams>,) => {
    return [
    'ai','converters', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiConvertersQueryOptions = <TData = Awaited<ReturnType<typeof listAiConverters>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListAiConvertersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiConverters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiConvertersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiConverters>>> = ({ signal }) => listAiConverters(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiConverters>>, TError, TData>
}

export type ListAiConvertersQueryResult = NonNullable<Awaited<ReturnType<typeof listAiConverters>>>
export type ListAiConvertersQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List AI Converters
 */

export function useListAiConverters<TData = Awaited<ReturnType<typeof listAiConverters>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListAiConvertersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiConverters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiConvertersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI Converter
 */
export const deleteAiConverter = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/converters/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiConverterMutationKey = () => ['deleteAiConverter'] as const;

export const getDeleteAiConverterMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConverter>>, TError,DeleteAiConverterMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiConverter>>, TError,DeleteAiConverterMutationVariables, TContext> => {

const mutationKey = getDeleteAiConverterMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiConverter>>, DeleteAiConverterMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiConverter(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiConverterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiConverter>>>

    export type DeleteAiConverterMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiConverterMutationVariables = {id: string}

    /**
 * @summary Delete AI Converter
 */
export const useDeleteAiConverter = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConverter>>, TError,DeleteAiConverterMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiConverter>>,
        TError,
        DeleteAiConverterMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiConverterMutationOptions(options), queryClient);
    }
    /**
 * @summary Show AI Converter
 */
export const getAiConverter = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiConverter>(
      {url: `/ai/converters/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiConverterQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','converters',id
    ] as const;
    }


export const getGetAiConverterQueryOptions = <TData = Awaited<ReturnType<typeof getAiConverter>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConverter>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiConverterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiConverter>>> = ({ signal }) => getAiConverter(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiConverter>>, TError, TData>
}

export type GetAiConverterQueryResult = NonNullable<Awaited<ReturnType<typeof getAiConverter>>>
export type GetAiConverterQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show AI Converter
 */

export function useGetAiConverter<TData = Awaited<ReturnType<typeof getAiConverter>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConverter>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiConverterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






